
import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/4a2a6b477d2273a3d0d5c5a7079aba9a/747489673424164d5fe42f0267ffc181.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="container mx-auto px-4 text-center text-white w-full">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            대청마을 북쯕 아파트 전경
          </h1>
          <p className="text-xl md:text-2xl mb-4 font-medium">
            국제교류복합지구와 한강을 조망하는 프리미엄 입지
          </p>
          <p className="text-lg md:text-xl mb-8 opacity-90">
            강남 중심권의 마지막 한강 조망지, 대청마을 북측의 미래 가치
          </p>
          
          {/* 주요 특징 */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10 text-left">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mb-4">
                <i className="ri-eye-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">영구 조망권 확보</h3>
              <p className="text-sm opacity-90">한강과 롯데타워를 동시에 누리는 프리미엄 뷰</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mb-4">
                <i className="ri-leaf-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">자연 친화적 환경</h3>
              <p className="text-sm opacity-90">하천과 공원으로 이어지는 조망과 개방감</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center mb-4">
                <i className="ri-building-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">펜트하우스급 주거</h3>
              <p className="text-sm opacity-90">조망·입지·환경이 어우러진 프리미엄</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mb-4">
                <i className="ri-map-pin-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">최고급 주거 벨트</h3>
              <p className="text-sm opacity-90">국제교류복합지구를 조망하는 강남권 입지</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center mb-4">
                <i className="ri-line-chart-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">50억원 이상 가치 상승</h3>
              <p className="text-sm opacity-90">강남 한강권 재건축 단지 수준 기대</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center mb-4">
                <i className="ri-team-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">전문가 참여</h3>
              <p className="text-sm opacity-90">체계적 사업성 검토와 계획 수립</p>
            </div>
          </div>

          {/* 추가 특징 */}
          <div className="bg-white/15 backdrop-blur-sm rounded-xl p-8 mb-12">
            <h2 className="text-2xl font-bold mb-6">프로젝트 핵심 가치</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
              <div>
                <h4 className="font-semibold mb-2 flex items-center">
                  <i className="ri-bar-chart-line text-blue-400 mr-2"></i>
                  입지와 조망에 따른 자산가치의 지속적 상승 전망
                </h4>
              </div>
              <div>
                <h4 className="font-semibold mb-2 flex items-center">
                  <i className="ri-file-chart-line text-green-400 mr-2"></i>
                  객관적 데이터 기반의 현실적 사업성 분석
                </h4>
              </div>
              <div>
                <h4 className="font-semibold mb-2 flex items-center">
                  <i className="ri-group-line text-purple-400 mr-2"></i>
                  소유자 참여와 투명한 의사결정 구조 마련
                </h4>
              </div>
              <div>
                <h4 className="font-semibold mb-2 flex items-center">
                  <i className="ri-global-line text-orange-400 mr-2"></i>
                  글로벌 건축사와의 협업으로 차별화된 도시 경관 실현
                </h4>
              </div>
            </div>
          </div>
          
          {/* CTA 버튼 */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="primary"
              size="lg"
              onClick={() => scrollToSection('consent-form')}
              className="text-lg px-8 py-4"
            >
              참여 동의서 작성하기
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={() => scrollToSection('notice')}
              className="text-lg px-8 py-4 border-white text-white hover:bg-white hover:text-gray-900"
            >
              설명회 일정 확인하기
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
